import type { GetUserStatsQuery } from '@/graphql/queries/GetUserStats.query';

import { GetUserStatsDocument } from '@/graphql/queries/GetUserStats.query';
import { paToParentIDMap } from '@/helpers/tracking/util/paParentMapping';
import { headerfulCachedRequest } from '@/helpers/request-helper';

/**
 * This here only fetches the user audiences for the Audience Refresh
 * currently done in `getAudienceContext` of TrackingHelper.
 */
export async function fetchUserAudiences(jwId?: string) {
	const response = await headerfulCachedRequest(GetUserStatsDocument, null, jwId);
	const data: GetUserStatsQuery | null = response?.data ?? null;

	const permanentAudiences = data?.stats.permanentAudiences ?? [];
	const parentPermanentAudiences = permanentAudiences
		.map(audienceID => audienceID.split('pa:')?.[1] || '')
		.flatMap(audienceID => (paToParentIDMap[audienceID] || []).map(pa => `pa:${pa.listId}`));

	return {
		permanentAudiences,
		parentPermanentAudiences,
	};
}
